import { useContactInstrumentsInfiniteQuery } from 'hooks/queries/useContactInstrumentsInfiniteQuery'
import { useWalletContactInstrumentsInfiniteQuery } from 'hooks/queries/useWalletContactInstrumentsInfiniteQuery'
import { InstrumentType } from 'types/contacts'

interface ContactInstrumentsSelectorQueryProps {
  searchTerm?: string
  paymentMethod?: InstrumentType
  walletLsid?: string
  size?: number
}

export const useContactInstrumentsSelectorQuery = (
  { searchTerm, paymentMethod, walletLsid, size }: ContactInstrumentsSelectorQueryProps,
  enableCryptoFiatSend = false
) => {
  const walletQuery = useWalletContactInstrumentsInfiniteQuery({
    walletLsid,
    searchTerm,
    size,
    enabled: enableCryptoFiatSend || !!walletLsid,
    isVersion3: enableCryptoFiatSend,
  })

  const contactQuery = useContactInstrumentsInfiniteQuery({
    searchTerm,
    paymentMethod,
    enabled: !enableCryptoFiatSend,
  })

  return enableCryptoFiatSend ? walletQuery : contactQuery
}
